<!-- Spacer -->
<div
    class="vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
